export enum ExpectedAnnualIncome {
  'UNDER_45_000' = '45_000',
  'UNDER_70_000' = '70_000',
  'UNDER_100_000' = '100_000',
  'UNDER_160_000' = '160_000',
  'UNDER_200_000' = '200_000',
  'OVER_200_000' = '200_000more',
}
